import React, { useState } from "react";
import Header from "../components/Layout/Header";
import Loader from "../components/Layout/Loader";
import ProfileSideBar from "../components/Profile/ProfileSidebar";
import ProfileContent from "../components/Profile/ProfileContent";
import { useSelector } from "react-redux";
import MyPostWidgetRedux from "../widgets/MyPostWidgetRedux";
import PostsWidgetRedux from "../widgets/PostsWidgetRedux";
import FriendListWidget from "../widgets/FriendListWidget";
import Sidebar from "../components/Layout/Sidebar";

const profileSettingsPanels = {
  1: {
    title: "Profile",
    eyebrow: "Account Settings",
    copy: "Review your public account details and contact information.",
  },
  2: {
    title: "Orders",
    eyebrow: "Commerce Settings",
    copy: "Review your order history and purchase details.",
  },
  3: {
    title: "Refunds",
    eyebrow: "Commerce Settings",
    copy: "Track refund requests and return activity.",
  },
  4: {
    title: "Inbox",
    eyebrow: "Messages",
    copy: "Read conversations and reply without leaving your profile settings.",
  },
  5: {
    title: "Track Order",
    eyebrow: "Commerce Settings",
    copy: "Check current order status and shipment progress.",
  },
  6: {
    title: "Change Password",
    eyebrow: "Security Settings",
    copy: "Update your password and keep your account secure.",
  },
  7: {
    title: "Address",
    eyebrow: "Delivery Settings",
    copy: "Manage saved addresses for checkout and delivery.",
  },
  9: {
    title: "Subscriptions",
    eyebrow: "Membership Settings",
    copy: "Review your current subscription and choose a plan without leaving profile settings.",
  },
};

const ProfilePage = () => {
  const [active, setActive] = useState(1);
  const { loading, user } = useSelector((state) => state.user);
  const picturePath = user?.picturePath;
  const _id = user?._id;

  const handleSetActive = (nextActive) => {
    setActive(nextActive);
  };

  const activePanel = profileSettingsPanels[active];

  const renderSettingsContent = () => (
    <section className="profile-settings-content-panel">
      {activePanel && (
        <header className="profile-settings-content-titlebar">
          <div>
            <p>{activePanel.eyebrow}</p>
            <h1>{activePanel.title}</h1>
            <span>{activePanel.copy}</span>
          </div>
        </header>
      )}
      <div className="profile-settings-content-card">
        <ProfileContent active={active} />
      </div>
    </section>
  );

  return (
    <div className="user-profile-dashboard-container">
      {loading ? (
        <Loader />
      ) : (
        <>
          <Header />
          <Sidebar />
          <div className="user-profile-dashboard-main">
            <aside className="user-profile-dashboard-sidebar">
              <ProfileSideBar active={active} setActive={handleSetActive} />
            </aside>

            <main className="user-profile-dashboard-content">
              <div className="user-profile-dashboard-content-container">
                <div className="profile-settings-inline-content">
                  {renderSettingsContent()}
                </div>
              </div>
            </main>
          </div>
        </>
      )}
    </div>
  );
};

export default ProfilePage;

